import bbitApi from '@api/make-request'
import {
  IRepository,
  numberArgs,
  IPathParamsArgs,
} from '@api/repositories/i-repository'
import { IUserGroupRoles } from '@app/interfaces/roles'
import { resolveParams } from '@app/utils/resolve-params/resolve-params'
import { AxiosResponse } from 'axios'

class RolesRepository implements IRepository<IUserGroupRoles> {
  create(data: IUserGroupRoles): Promise<AxiosResponse<IUserGroupRoles>> {
    return bbitApi.post('/api/v1/group-roles', data)
  }

  getAll(args: IPathParamsArgs): Promise<AxiosResponse<IUserGroupRoles[]>> {
    return bbitApi.get(`/api/v1/group-roles`, {
      params: resolveParams(args),
      cancelToken: args.source?.token,
    })
  }

  getOne(args: numberArgs): Promise<AxiosResponse<IUserGroupRoles>> {
    return bbitApi.get(`/api/v1/group-roles/${args.data}`, {
      cancelToken: args.source?.token,
    })
  }

  update(data: IUserGroupRoles): Promise<AxiosResponse<IUserGroupRoles>> {
    return bbitApi.put(`/api/v1/group-roles/${data.id}`, data)
  }
}

export default new RolesRepository()
